import React, {useEffect, useState} from 'react';
import {Image, Pressable, StyleSheet, Text, View, ScrollView} from 'react-native';
import {useDropzone} from 'react-dropzone';

const CampImages = ({camp, setCamp}) => {
    const [images, setImages] = useState(
        (camp && camp.campImages) ? camp.campImages : []
    );

    useEffect(() => {
        setCamp(prevState => ({
            ...prevState,
            campImages: images,
        }));
    }, [images]);

    const handleDrop = (acceptedFiles) => {
        const newImages = acceptedFiles.map(file => ({
            url: URL.createObjectURL(file),
            name: file.name,
            type: file.type,
        }));

        setImages(prevImages => [...prevImages, ...newImages]);
    };

    const handleRemoveImage = (index) => {
        const newImages = images.filter((_, i) => i !== index);
        setImages(newImages);
    };

    const {getRootProps, getInputProps} = useDropzone({
        onDrop: handleDrop,
        accept: 'image/*',
        multiple: true,
    });

    return (
        <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
            <View style={styles.field}>
                <Text style={styles.title}>Camp Images</Text>
                <Text style={styles.subtitle}>Upload some images to showcase your camp activities.</Text>
            </View>

            <View {...getRootProps({className: 'dropzone'})} style={styles.dropzone}>
                <input {...getInputProps()} />
                <Text style={styles.dropzoneText}>Drag 'n' drop/click to select images for your camp</Text>
            </View>

            <Text style={{fontSize: 20, fontWeight: 'bold'}}>Images Preview</Text>

            <View style={{flexDirection: 'row', marginTop: 30}}>
                {images.map((image, index) => (
                    <View key={index} style={styles.imageContainer}>
                        <Image
                            source={{uri: image.url}}
                            style={styles.image}
                        />
                        <Pressable
                            onPress={() => handleRemoveImage(index)}
                            style={styles.removeButton}
                        >
                            <Text style={styles.removeButtonText}>
                                remove
                            </Text>
                        </Pressable>
                    </View>
                ))}
            </View>
        </ScrollView>
    );
};

const styles = StyleSheet.create({
    dropzone: {
        width: '100%',
        height: 150,
        borderWidth: 2,
        borderColor: '#cccccc',
        borderStyle: 'dashed',
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 20,
        backgroundColor: '#f9f9f9',
    },
    dropzoneText: {
        color: '#cccccc',
        fontSize: 16,
    },
    previewContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    imageContainer: {
        flexDirection: 'column',
        alignItems: 'center',
        marginRight: 10,
    },
    image: {
        width: 200,
        height: 100,
        borderRadius: 8,
    },
    removeButton: {
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 15,
        padding: 5,
    },
    removeButtonText: {
        color: 'black',
        fontWeight: 'bold',
        fontSize: 12,
    },
    field: {
        flexDirection: 'column',
        marginBottom: 30,
    },
    container: {
        flex: 1,
    },
    contentContainer: {
        paddingHorizontal: 120,
        paddingTop: 40,
        paddingBottom: 40,
    },
    input: {
        height: 40,
        borderColor: 'gray',
        borderWidth: 1,
        marginBottom: 20,
        paddingHorizontal: 10,
    },
    title: {
        fontSize: 35,
        color: 'black',
        fontWeight: '600',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 15,
        color: 'grey',
    },
    removeText: {
        position: 'absolute',
        top: 5,
        right: 5,
        color: 'red',
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 15,
        padding: 5,
    },
    uploadButtonText: {
        color: '#ffffff',
        fontSize: 16,
        fontWeight: 'bold',
    },
    uploadButton: {
        backgroundColor: 'black',
        borderRadius: 8,
        paddingVertical: 10,
        paddingHorizontal: 20,
        width: '20%',
    },
});

export default CampImages;
